<template>
  <div>
    <div>
      <div class="row my-4 mx-1 justify-content-center">
        <v-container v-if="progress" type="image" class="loding">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-container>
        <div v-else class="col-lg-8 col-sm-12 col-md-10 borderPointier">
          <div class="background-white">
            <div class="title">
              <div class="position">{{ $t("conditions_technique") || "Conditions techniques" }}</div>
            </div>
          </div>
          <form @submit.prevent="barSe108Add" class="my-3">
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                L'opération concerne une installation individuelle de chauffage  <span class="text-danger">*</span>
              </div>
              <div class="d-flex gap-4">
                <b-form-radio v-model="barSe108Data.installation_individuelle" :value="true" name="installationIndividuelle">OUI</b-form-radio>
                <b-form-radio v-model="barSe108Data.installation_individuelle" :value="false" name="installationIndividuelle">NON</b-form-radio>
              </div>
            </div>

            <div class="fieldset mb-2">
              <div class="legend mb-2">
                La ou les boucles d'eau chauffées, en tout ou partie, par une pompe à chaleur de type air/eau, eau/eau ou sol/eau ou par une pompe à chaleur hybride sont exclues : <span class="text-danger">*</span>
              </div>
              <div class="d-flex gap-4">
                <b-form-radio v-model="barSe108Data.boucles_pac_exclues" :value="true" name="bouclesPacExclues">OUI</b-form-radio>
                <b-form-radio v-model="barSe108Data.boucles_pac_exclues" :value="false" name="bouclesPacExclues">NON</b-form-radio>
              </div>
            </div>

            <div class="fieldset mb-2">
              <div class="legend mb-2">
                Puissance thermique nominale de l'installation de chauffage (kW)  <span class="text-danger">*</span>
              </div>
              <b-form-input
                type="number"
                min="0"
                step="0.01"
                v-model="barSe108Data.puissance_thermique_kw"
                placeholder="kW"
                class="form-input custom-placeholder custom-input"
                @paste="(event) => onPaste(event, 'barSe108Data.puissance_thermique_kw')"
                @keydown="(event) => onKeyDown(event)"
              />
            </div>

            <div class="fieldset mb-2">
              <div class="legend mb-2">
                Les étapes suivantes ont été réalisées (cocher les cases concernées)  <span class="text-danger">*</span>
              </div>
              <div class="etapes-list">
                <b-form-checkbox v-model="barSe108Data.etape_rinçage_eau" class="mb-2">
                  Rinçage à l'eau du système de distribution par boucle d'eau (général puis réseau par réseau)
                </b-form-checkbox>
                <b-form-checkbox v-model="barSe108Data.etape_injection_desembouant" class="mb-2">
                  Injection d'un réactif désembouant et circulation selon le dosage et le temps de contact préconisés, avec l'utilisation d'une pompe de désembouage (général puis réseau par réseau ; dans les deux sens de circulation)
                </b-form-checkbox>
                <b-form-checkbox v-model="barSe108Data.etape_rinçage_eau_claire" class="mb-2">
                  Rinçage des circuits à l'eau claire (général puis réseau par réseau)
                </b-form-checkbox>
                <b-form-checkbox v-model="barSe108Data.etape_verification_filtre" class="mb-2">
                  Vérification du filtre (ou pot à boues) existant et/ou installation d'un filtre sur le ou les circuits de retour au générateur, ainsi que l'injection d'un réactif inhibiteur au dosage préconisé
                </b-form-checkbox>
              </div>
            </div>

            <!-- Champs contact sur site -->
            <div class="fieldset mb-2">
              <div class="legend mb-2">{{ $t("Contact sur site") || "Contact sur site" }}</div>
              <b-form-input
                type="text"
                v-model="contactSurSite"
                :placeholder="$t('Contact sur site') || 'Contact sur site'"
                class="form-input custom-placeholder custom-input"
                @input="updateContactSurSite"
              />
            </div>

            <div class="fieldset mb-2">
              <div class="legend mb-2">{{ $t("Fonction") || "Fonction" }}</div>
              <b-form-input
                type="text"
                v-model="fonctionContact"
                :placeholder="$t('Fonction') || 'Fonction'"
                class="form-input custom-placeholder custom-input"
                @input="updateFonctionContact"
              />
            </div>

            <div class="fieldset mb-2">
              <div class="legend mb-2">{{ $t("Téléphone") || "Téléphone" }}</div>
              <phone :tel="telephoneContact" @phoneNumber="formatTelephoneContact($event)"></phone>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="!show" class="d-flex justify-content-end mt-4">
      <b-button @click="goToPrevStep" class="button-pre-style m-3">{{ $t("PREVIOUS") }}</b-button>
      <b-button type="submit" @click="goToStep" class="button-suivant-style m-3">
        {{ $t("NEXT") }}
        <div class="loading ml-2" v-if="isLoading">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
        <div class="loading ml-2" v-if="isLoadingButton">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
      </b-button>
    </div>

    <Snackbar ref="snackbar" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import domain from "@/environment";
import axios from "axios";
import Snackbar from "@/components/ui/errorSnackbar.vue";
import phone from "@/components/ui/phone.vue";
import { handlePaste, preventExceedingLengthFloat } from "@/utils/inputUtils";

export default {
  components: {
    Snackbar,
    phone,
  },
  props: {
    isLoadingButton: { type: Boolean, default: false },
    visibleTabsLength: { type: Number, required: true },
    progress: { type: Boolean, default: false },
    show: { type: Boolean, default: false },
  },

  data() {
    return {
      isCompleted: false,
      errorMessage: "",
      isLoading: false,
      barSe108Data: {
        installation_individuelle: null,
        boucles_pac_exclues: null,
        puissance_thermique_kw: null,
        etape_rinçage_eau: false,
        etape_injection_desembouant: false,
        etape_rinçage_eau_claire: false,
        etape_verification_filtre: false,
      },
      contactSurSite: null,
      fonctionContact: null,
      telephoneContact: null,
    };
  },

  created() {
    if (this.getdevisMonoFiche && this.getdevisMonoFiche.data) {
      this.barSe108Data = this.initializeBarSe108();
      this.initializeContactFields();
    }
  },

  computed: {
    ...mapState({ token: (state) => state.token }),
    ...mapGetters(["getdevisMonoFiche"]),
    buttonText() {
      return this.visibleTabsLength <= 1 ? this.$t("NEXT") : this.$t("CONFIRMER");
    },
  },

  watch: {
    getdevisMonoFiche: {
      handler(newDevis) {
        if (newDevis && newDevis.data) {
          const currentData = this.barSe108Data ? { ...this.barSe108Data } : null;
          this.barSe108Data = this.initializeBarSe108();
          if (currentData) {
            Object.keys(currentData).forEach((key) => {
              if (currentData[key] !== undefined && currentData[key] !== null) {
                this.barSe108Data[key] = currentData[key];
              }
            });
          }
          this.initializeContactFields();
          const existing = newDevis.data?.devis?.desembouage_reseau_hydraulique_individuel_chauffage;
          if (existing !== null && existing !== undefined) {
            this.isCompleted = true;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActions(["setDevisMonoFiche"]),
    onKeyDown(event) {
      preventExceedingLengthFloat(event);
    },
    onPaste(event, fieldName) {
      handlePaste.call(this, event, fieldName);
    },

    toBoolFromApi(v) {
      if (v === null || v === undefined) return null;
      return v === 1 || v === true || v === "1";
    },

    buildApiPayload() {
      const toNumericBool = (v) => {
        if (v === null || v === undefined) return null;
        return v ? 1 : 0;
      };
      const devisId = this.getdevisMonoFiche?.data?.devis?.id;
      return {
        devis_id: devisId,
        installation_individuelle: toNumericBool(this.barSe108Data.installation_individuelle),
        boucles_pac_exclues: toNumericBool(this.barSe108Data.boucles_pac_exclues),
        puissance_thermique_kw: this.barSe108Data.puissance_thermique_kw,
        etape_rinçage_eau: toNumericBool(this.barSe108Data.etape_rinçage_eau),
        etape_injection_desembouant: toNumericBool(this.barSe108Data.etape_injection_desembouant),
        etape_rinçage_eau_claire: toNumericBool(this.barSe108Data.etape_rinçage_eau_claire),
        etape_verification_filtre: toNumericBool(this.barSe108Data.etape_verification_filtre),
      };
    },

    initializeBarSe108() {
      const data = this.getdevisMonoFiche?.data?.devis?.desembouage_reseau_hydraulique_individuel_chauffage || {};
      return {
        installation_individuelle: this.toBoolFromApi(data.installation_individuelle) ?? null,
        boucles_pac_exclues: this.toBoolFromApi(data.boucles_pac_exclues) ?? null,
        puissance_thermique_kw: data.puissance_thermique_kw ?? null,
        etape_rinçage_eau: this.toBoolFromApi(data.etape_rinçage_eau) ?? false,
        etape_injection_desembouant: this.toBoolFromApi(data.etape_injection_desembouant) ?? false,
        etape_rinçage_eau_claire: this.toBoolFromApi(data.etape_rinçage_eau_claire) ?? false,
        etape_verification_filtre: this.toBoolFromApi(data.etape_verification_filtre) ?? false,
      };
    },

    async postDesembouageReseau(payload) {
      try {
        const response = await axios.post(
          domain + `/desembouage_reseau_hydraulique_individuel_chauffage`,
          payload,
          { headers: { Authorization: `Bearer ${this.token}` } }
        );
        return response.data.data;
      } catch (error) {
        if (error.response?.data?.message) {
          this.errorMessage = error.response.data.message;
        } else if (error.response?.data?.errors) {
          this.errorMessage = Array.isArray(error.response.data.errors)
            ? error.response.data.errors.join(", ")
            : error.response.data.errors;
        } else {
          this.errorMessage = "Vérifiez vos données.";
        }
        this.$refs.snackbar.showSnackbar(this.errorMessage);
        return null;
      }
    },

    async putDesembouageReseau(payload) {
      try {
        const response = await axios.put(
          domain + `/desembouage_reseau_hydraulique_individuel_chauffage/${payload.id}`,
          payload,
          { headers: { Authorization: `Bearer ${this.token}` } }
        );
        return response.data.data;
      } catch (error) {
        if (error.response?.data?.message) {
          this.errorMessage = error.response.data.message;
        } else if (error.response?.data?.errors) {
          this.errorMessage = Array.isArray(error.response.data.errors)
            ? error.response.data.errors.join(", ")
            : error.response.data.errors;
        } else {
          this.errorMessage = "Vérifiez vos données.";
        }
        this.$refs.snackbar.showSnackbar(this.errorMessage);
        return null;
      }
    },

    desembouageReseauAdd() {
      const existing = this.getdevisMonoFiche?.data?.devis?.desembouage_reseau_hydraulique_individuel_chauffage;
      const existingId = existing?.id || this.barSe108Data?.id;
      if (existingId) {
        const payload = { ...this.buildApiPayload(), id: existingId };
        return this.putDesembouageReseau(payload);
      }
      return this.postDesembouageReseau(this.buildApiPayload());
    },

    validateBarSe108() {
      if (this.barSe108Data.installation_individuelle === null) {
        this.$refs.snackbar.showSnackbar("Veuillez indiquer si l'opération concerne une installation individuelle de chauffage.");
        return false;
      }
      if (this.barSe108Data.boucles_pac_exclues === null) {
        this.$refs.snackbar.showSnackbar("Veuillez indiquer si les boucles d'eau chauffées par PAC sont exclues.");
        return false;
      }
      if (this.barSe108Data.puissance_thermique_kw === null || this.barSe108Data.puissance_thermique_kw === "") {
        this.$refs.snackbar.showSnackbar("Veuillez saisir la puissance thermique nominale (kW).");
        return false;
      }
      const atLeastOne =
        this.barSe108Data.etape_rinçage_eau ||
        this.barSe108Data.etape_injection_desembouant ||
        this.barSe108Data.etape_rinçage_eau_claire ||
        this.barSe108Data.etape_verification_filtre;
      if (!atLeastOne) {
        this.$refs.snackbar.showSnackbar("Veuillez cocher au moins une étape réalisée.");
        return false;
      }
      return true;
    },

    async barSe108Add() {
      return this.desembouageReseauAdd();
    },

    async goToStep() {
      this.isLoading = true;
      this.isCompleted = false;
      this.errorMessage = "";
      if (!this.validateBarSe108()) {
        this.isLoading = false;
        return;
      }
      const response = await this.desembouageReseauAdd();
      if (response && response.id) {
        this.getdevisMonoFiche.data.devis.desembouage_reseau_hydraulique_individuel_chauffage_id = response.id;
        this.getdevisMonoFiche.data.devis.desembouage_reseau_hydraulique_individuel_chauffage = {
          id: response.id,
          installation_individuelle: this.barSe108Data.installation_individuelle ? 1 : 0,
          boucles_pac_exclues: this.barSe108Data.boucles_pac_exclues ? 1 : 0,
          puissance_thermique_kw: this.barSe108Data.puissance_thermique_kw,
          etape_rinçage_eau: this.barSe108Data.etape_rinçage_eau ? 1 : 0,
          etape_injection_desembouant: this.barSe108Data.etape_injection_desembouant ? 1 : 0,
          etape_rinçage_eau_claire: this.barSe108Data.etape_rinçage_eau_claire ? 1 : 0,
          etape_verification_filtre: this.barSe108Data.etape_verification_filtre ? 1 : 0,
        };
        this.setDevisMonoFiche(this.getdevisMonoFiche);
        this.isCompleted = true;
      }
      this.isLoading = false;
      if (this.isCompleted && this.visibleTabsLength <= 1) {
        this.$emit("change", true);
      } else if (this.isCompleted) {
        this.$emit("change", false);
      }
    },

    goToPrevStep() {
      if (this.visibleTabsLength <= 1) {
        this.$emit("changePrev", true);
      } else {
        this.$emit("changePrev", false);
      }
      this.$emit("changeStep", 3);
    },

    initializeContactFields() {
      const devis = this.getdevisMonoFiche?.data?.devis;
      this.contactSurSite = devis?.contact_sur_site || null;
      this.fonctionContact = devis?.fonction_contact || null;
      this.telephoneContact = devis?.telephone_contact || null;
    },

    updateContactSurSite() {
      this.getdevisMonoFiche.data.devis.contact_sur_site = this.contactSurSite || null;
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },

    updateFonctionContact() {
      this.getdevisMonoFiche.data.devis.fonction_contact = this.fonctionContact || null;
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },

    formatTelephoneContact(event) {
      if (event && event.number && event.country) {
        this.telephoneContact = {
          phone_number: event.number,
          phone_iso_code: event.country.iso2,
          formated_phone: event.formatted || null,
        };
        this.getdevisMonoFiche.data.devis.telephone_contact = this.telephoneContact;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      } else if (!event || !event.number) {
        this.telephoneContact = null;
        this.getdevisMonoFiche.data.devis.telephone_contact = null;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      }
    },
  },
};
</script>

<style scoped>
.custom-placeholder::placeholder {
  font-size: 13px;
}
.form-input {
  font-size: 13px;
  height: 41.1px !important;
}
.borderPointier {
  border: 2px dashed #24316d;
  position: relative;
}
.background-white {
  display: inline-block;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  position: absolute;
  top: -1rem;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
}
.title {
  color: #24316d;
  position: relative;
  z-index: 2;
  margin: 0;
}
.position {
  background-color: white;
  display: inline-block;
  padding: 0.05rem 2rem;
}
.custom-input {
  box-shadow: none;
}
.etapes-list {
  padding: 0.5rem 0;
}
.etapes-list .form-check {
  font-size: 13px;
}
</style>
